import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class MuseumsService 
{


  async fetchMuseums(): Promise<any> 
  {
    const remoteMuseums = await this.fetchRemoteMuseums();
    if (remoteMuseums) 
    {
      console.log('fetchMuseums:: Informazioni sulle musei scaricarte dal server.');
      return remoteMuseums;
    }
    return this.fetchMuseumsFromStorage();
  }


  async fetchMuseumsFromStorage(): Promise<any> 
  {
    try 
    {
      console.log('fetchMuseumsFromStorage:: cerco informazioni sulle musei in memoria');
      
      const museums = await localStore.get("museumslist");
      if (museums != null) 
      {
        console.log('fetchMuseumsFromStorage:: Informazioni sulle musei presenti in memoria.');
        return museums;
      }

      console.log('Non sono presenti informazioni sulle musei in memoria - riavviare l\'app e  riprovare');
      return null;
    }
    catch (error) 
    {
      console.log('Problema nella ricezione dei dati sulle musei - riavviare l\'app e riprovare ', error);
      throw error;
    }
  }


  
  async fetchRemoteMuseums(): Promise<[any] | null> 
  {
    console.log('fetchRemoteMuseums:: cerco musei sul server');

    return new Promise((resolve, reject) => {
      const url = `${BASE_URL}/poServer.php?act=17&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('Informazioni sulle musei scaricarte dal server.');
            localStore.set('museumslist', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sulle musei - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }
}

export default MuseumsService; 